export default "__VITE_ASSET__CX74gQVy__"